/* src/app/admin-dashboard/site-system/records/jsd-logs/jsd-log.css */
/*# sourceMappingURL=jsd-log.css.map */
